'use strict';

exports = module.exports = function() {
    return exports;
};

if (process.env.NODE_ENV !== 'production') {
    exports._debug = require('debug');
    // _debug.enable('hbnb:invoke:*');
}

// invoke
exports._invoke = require('./invoke/index.js');

// hbnb
exports.core = require('./core/index.js');

// basic
exports.account = require('./account/index.js');
exports.log = require('./log/index.js');
exports.network = require('./network/index.js');
exports.pay = require('./pay/index.js');
exports.position = require('./position/index.js');
exports.storage = require('./storage/index.js');
exports.thirdApps = require('./thirdApps/index.js');
exports.ui = require('./ui/index.js');
exports.webview = require('./webview/index.js');

// tower
exports.tower = require('./tower/index.js');

//flight
exports.flight = require('./flight/index.js');

//train
exports.train = require('./train/index.js');
exports.inject = require('./inject/index.js');

//lvyou
window.Bridge = require('./legency-lvyou/index.js');
exports.travel = require('./travel/index.js');

//env
exports.env = require('./env/index.js');

//share
exports.share = require('./share/index.js');




//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/index.js
// module id = 586
// module chunks = 0